import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsProducingOrFinishedProductionResourceAvailable } from "../selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable";
export var checkAnyBuildingWhichProducesResourceIdProductionDonePremiumAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var resourceId = action.taskType.resourceId;
    var availableBuildings = selectBuildingsProducingOrFinishedProductionResourceAvailable(state, resourceId);
    var buildingsWithProductionFinished = availableBuildings.filter(utilBuildings.hasFinishedProduction);
    var doesPremiumBuildingExists = buildingsWithProductionFinished.some(utilBuildings.isPremium);
    return doesPremiumBuildingExists ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyBuildingWhichProducesResourceIdProductionDonePremiumAvailable.ts
// module id = 2357
// module chunks = 3